import gql from 'graphql-tag'

export const GET_USER_WITH_GROUPS_QUERY = gql`
	query ( $id: Int! ) {
		getUser(data: { id: $id }) {
			id
			email
			firstName
			lastName
			fullName
			shortFullName
			telNumber
			isActive
			image
			userGroupAlt
		}
		getUserGroups {
			alt
		}
	}
`

export const GET_USERS_PAGINATION_QUERY = gql`
	query GetUsersPagination (
		$orderBy: [OrderByInput!],
		$skip: Int!,
		$take: Int!,
	) {
		getUsers(
			data: {
				orderBy: $orderBy
				pagination: {
					skip: $skip
					take: $take
				}
			}
		){
			hasMore
			total
			items {
				id
				isActive
				image
				email
				telNumber
				firstName
				lastName
				fullName
				shortFullName
				userGroupAlt
			}
		}
	}
`
